import React from "react";
import { Dialog, DialogTitle, DialogContent, Button, CircularProgress } from "@mui/material";
import API from "../API";
import { Document, Page } from "./pdfRenderer";

function PdfDocument({ url }) {
  const container = React.useRef(null);
  const [width, setWidth] = React.useState(280);
  const [pages, setPages] = React.useState(0);
  const [page, setPage] = React.useState(1);
  const [failed, setFailed] = React.useState(false);

  React.useEffect(() => {
    const resize = () => {
      if (container.current) setWidth(container.current.clientWidth || 280);
    };
    resize();
    const observer = typeof ResizeObserver !== "undefined" ? new ResizeObserver(resize) : null;
    if (observer) observer.observe(container.current);
    window.addEventListener("resize", resize);
    return () => {
      if (observer) observer.disconnect();
      window.removeEventListener("resize", resize);
    };
  }, []);

  return <div ref={container} style={{ width: "100%" }}>
    {failed ? <p role="alert">PDF görüntülenemedi. Lütfen kapatıp tekrar deneyin.</p> : <>
      {pages > 1 && <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Button disabled={page === 1} onClick={() => setPage(page - 1)}>Önceki</Button>
        <span aria-live="polite">{page} / {pages}</span>
        <Button disabled={page === pages} onClick={() => setPage(page + 1)}>Sonraki</Button>
      </div>}
      <Document file={url} loading={<CircularProgress />} onLoadSuccess={({ numPages }) => setPages(numPages)} onLoadError={() => setFailed(true)}>
        <Page pageNumber={page} width={width} renderTextLayer={false} renderAnnotationLayer={false} loading={<CircularProgress />} onLoadError={() => setFailed(true)} onRenderError={() => setFailed(true)} />
      </Document>
    </>}
  </div>;
}

export default function SecureDocumentViewer() {
  const [request, setRequest] = React.useState(null);
  const [document, setDocument] = React.useState(null);
  const [error, setError] = React.useState("");
  React.useEffect(() => {
    const open = (event) => { setDocument(null); setError(""); setRequest(event.detail); };
    window.addEventListener("panel-document-view", open);
    return () => window.removeEventListener("panel-document-view", open);
  }, []);
  React.useEffect(() => {
    if (!request) return;
    const controller = new AbortController();
    let url;
    API.fetchDocument(request, controller.signal).then((blob) => {
      if (controller.signal.aborted) return;
      url = URL.createObjectURL(blob);
      setDocument({ url, type: blob.type });
    }).catch((err) => { if (!controller.signal.aborted) setError(err.message); });
    return () => { controller.abort(); if (url) URL.revokeObjectURL(url); };
  }, [request]);
  const close = () => { setRequest(null); setDocument(null); setError(""); };
  return <Dialog open={!!request} onClose={close} fullWidth maxWidth="lg">
    <DialogTitle>Belge <Button onClick={close}>Kapat</Button></DialogTitle>
    <DialogContent>{error || (document ? document.type === "application/pdf" ? <PdfDocument key={document.url} url={document.url} /> : <img alt="Seçilen belge" src={document.url} style={{ maxWidth: "100%", maxHeight: "75vh" }} /> : <CircularProgress />)}</DialogContent>
  </Dialog>;
}
